// extracted by mini-css-extract-plugin
export default {"brandTrendingWrap":"aK-z"};